"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberInput = exports.NumberStepper = exports.NumberInputWrapper = exports.NumberInputArea = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var AutoGrowTextInput_1 = __importDefault(require("AutoGrowTextInput/AutoGrowTextInput"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var lodash_1 = require("lodash");
var NumberInputArea = (0, react_1.forwardRef)(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, handleStep = _a.handleStep, onEnterOrBlur = _a.onEnterOrBlur, isShowingError = _a.isShowingError, errorMessage = _a.errorMessage, hideError = _a.hideError, autogrow = _a.autogrow, rest = __rest(_a, ["value", "onChange", "handleStep", "onEnterOrBlur", "isShowingError", "errorMessage", "hideError", "autogrow"]);
    var handleBlur = function (event) {
        var _a;
        onEnterOrBlur();
        (_a = rest.onBlur) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var handleKeyDown = function (event) {
        var _a;
        hideError();
        switch (event.key) {
            case kaleidoscope_1.KeyType.ArrowUp:
                event.preventDefault();
                handleStep("up");
                break;
            case kaleidoscope_1.KeyType.ArrowDown:
                event.preventDefault();
                handleStep("down");
                break;
            case kaleidoscope_1.KeyType.Enter:
                event.preventDefault();
                onEnterOrBlur();
                break;
        }
        (_a = rest.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var Element = autogrow ? AutoGrowTextInput_1.default : kaleidoscope_1.TextInput;
    return (react_1.default.createElement("div", { className: "number-input__input" },
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: errorMessage, show: isShowingError, size: kaleidoscope_1.TooltipSize.Large, isError: true },
            react_1.default.createElement(Element, __assign({}, rest, { value: value, onChange: onChange, onBlur: handleBlur, onKeyDown: handleKeyDown, inputMode: "numeric", role: "spinbutton", ref: ref })))));
});
exports.NumberInputArea = NumberInputArea;
NumberInputArea.displayName = "NumberInputArea";
var NumberStepper = function (_a) {
    var onChange = _a.onChange, upDisabled = _a.upDisabled, downDisabled = _a.downDisabled, verticalOffset = _a.verticalOffset, rest = __rest(_a, ["onChange", "upDisabled", "downDisabled", "verticalOffset"]);
    return (react_1.default.createElement("div", { className: "number-input__stepper", style: { top: verticalOffset } },
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: "number-input__step-button", onClick: function () { return onChange("up"); }, size: kaleidoscope_1.ButtonSize.XSmall, icon: react_1.default.createElement(icons_1.ChevronUp, { size: icons_1.IconSize.Small }), disabled: upDisabled, "aria-label": "Increase", "data-qwilr-component": rest["data-qwilr-component"] ? "".concat(rest["data-qwilr-component"], "-up-step") : null }),
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: "number-input__step-button", onClick: function () { return onChange("down"); }, size: kaleidoscope_1.ButtonSize.XSmall, icon: react_1.default.createElement(icons_1.ChevronDown, { size: icons_1.IconSize.Small }), disabled: downDisabled, "aria-label": "Decrease", "data-qwilr-component": rest["data-qwilr-component"] ? "".concat(rest["data-qwilr-component"], "-down-step") : null })));
};
exports.NumberStepper = NumberStepper;
var isWithinBoundaries = function (value, min, max) {
    if (min !== undefined && value < min) {
        return false;
    }
    else if (max !== undefined && value > max) {
        return false;
    }
    return true;
};
var getBoundaryErrorMessage = function (min, max) {
    var minExists = min != undefined;
    var maxExists = max != undefined;
    if (minExists && maxExists) {
        return "Must be between ".concat(min, " and ").concat(max, " ");
    }
    if (minExists) {
        return "Must be at least ".concat(min);
    }
    return "Must be at most ".concat(max);
};
var useNumberInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, min = _a.min, max = _a.max, disabled = _a.disabled, _b = _a.stepSize, stepSize = _b === void 0 ? 1 : _b, rest = __rest(_a, ["value", "onChange", "min", "max", "disabled", "stepSize"]);
    var _c = __read((0, react_1.useState)(undefined), 2), inputValue = _c[0], setInputValue = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isShowingBoundaryError = _d[0], setIsShowingBoundaryError = _d[1];
    var _e = __read((0, react_1.useState)(undefined), 2), boundaryErrorTimeout = _e[0], setBoundaryErrorTimeout = _e[1];
    var showBoundaryError = function () {
        if (boundaryErrorTimeout !== undefined) {
            window.clearTimeout(boundaryErrorTimeout);
            setBoundaryErrorTimeout(undefined);
        }
        setIsShowingBoundaryError(true);
        setBoundaryErrorTimeout(window.setTimeout(function () {
            hideBoundaryError();
        }, 4000));
    };
    var hideBoundaryError = function () {
        if (boundaryErrorTimeout !== undefined) {
            window.clearTimeout(boundaryErrorTimeout);
            setBoundaryErrorTimeout(undefined);
        }
        setIsShowingBoundaryError(false);
    };
    var onInputChange = function (newValue) {
        var valueAsNumber = Number(newValue);
        if (isNaN(valueAsNumber)) {
            setInputValue(newValue);
            return;
        }
        if (!isWithinBoundaries(valueAsNumber, min, max)) {
            setInputValue(newValue);
            return;
        }
        if (valueAsNumber.toString() !== newValue) {
            setInputValue(newValue);
        }
        else {
            setInputValue(undefined);
        }
        onChange(valueAsNumber);
    };
    var validateAndClearInputValue = function () {
        var inputValueAsNumber = Number(inputValue);
        if (!isNaN(inputValueAsNumber) && !isWithinBoundaries(inputValueAsNumber, min, max)) {
            showBoundaryError();
        }
        setInputValue(undefined);
    };
    var handleStep = function (direction) {
        var _a;
        var currentValue = (_a = value !== null && value !== void 0 ? value : { up: min, down: max }[direction]) !== null && _a !== void 0 ? _a : 0;
        var newValue = { up: (0, CommonUtils_1.safePlus)(currentValue, stepSize), down: (0, CommonUtils_1.safePlus)(currentValue, -stepSize) }[direction];
        setInputValue(undefined);
        var clampedNewValue = (0, lodash_1.clamp)(newValue, min !== null && min !== void 0 ? min : Number.NEGATIVE_INFINITY, max !== null && max !== void 0 ? max : Number.POSITIVE_INFINITY);
        if (!isWithinBoundaries(newValue, min, max)) {
            if (clampedNewValue === currentValue) {
                showBoundaryError();
                return;
            }
            else {
                onChange(clampedNewValue);
                return;
            }
        }
        onChange(newValue);
    };
    var offsetForUnderline = rest.variant === kaleidoscope_1.TextInputVariant.Underlined ? 2 : 0;
    var offsetForLabel = rest.labelHidden ? 0 : 11.6;
    return {
        inputProps: __assign({ value: inputValue !== null && inputValue !== void 0 ? inputValue : (value !== null ? value.toString() : ""), onChange: onInputChange, handleStep: handleStep, onEnterOrBlur: validateAndClearInputValue, isShowingError: isShowingBoundaryError, errorMessage: getBoundaryErrorMessage(min, max), hideError: hideBoundaryError, disabled: disabled }, rest),
        stepperProps: {
            onChange: handleStep,
            upDisabled: (max !== undefined && value !== null && value >= max) || disabled,
            downDisabled: (min !== undefined && value !== null && value <= min) || disabled,
            "data-qwilr-component": rest["data-qwilr-component"],
            verticalOffset: offsetForUnderline + offsetForLabel,
        },
    };
};
exports.useNumberInput = useNumberInput;
var NumberInputWrapper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "number-input" }, children));
};
exports.NumberInputWrapper = NumberInputWrapper;
var NumberInput = (0, react_1.forwardRef)(function (_a, ref) {
    var showStepper = _a.showStepper, rest = __rest(_a, ["showStepper"]);
    var _b = useNumberInput(rest), inputProps = _b.inputProps, stepperProps = _b.stepperProps;
    return (react_1.default.createElement(NumberInputWrapper, null,
        react_1.default.createElement(NumberInputArea, __assign({}, inputProps, { ref: ref })),
        showStepper && react_1.default.createElement(NumberStepper, __assign({}, stepperProps))));
});
NumberInput.displayName = "NumberInput";
exports.default = (0, mobx_react_1.observer)(NumberInput);
